import { takeLatest, call, put } from 'redux-saga/effects'
import foldersList from 'api/administration/folders/List'
import * as fromActions from '../../actions/folders.action'

async function getList() {
  return await foldersList()
}

function* foldersListEffectSaga() {
  try {
    const { data } = yield call(getList)
    yield put(fromActions.Actions.foldersAdministrationListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* foldersListWatcherSaga() {
  yield takeLatest(fromActions.FOLDERS_ADMINISTRATION_LIST, foldersListEffectSaga)
}
